import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { getCountries } from "../../services/countries";
import { formatMediaUrl } from "../../../utils/formatters/formatMedia";

export const useCountryListing = () => {
  const { i18n } = useTranslation();

  const {
    data,
    isLoading: isCountriesDataLoading,
    isError: isCountriesDataHasError,
  } = useQuery({
    queryKey: ["Countries", i18n.language],
    queryFn: async () => await getCountries(),
  });

  const countries =
    data?.map((el: any) => ({
      label: el.name,
      value: el.id,
      url: el.url,
      shortCode: el.shortCode,
      flagSrc: formatMediaUrl(el.url),
      nationality: el.nationality,
      xCoord: el.xCoord,
      yCoord: el.yCoord,
    })) || [];

  const nationalities =
    data?.map((el: any) => ({
      label: `${el.nationality} - ${el.name}`,
      value: el.id,
    })) || [];

  return { countries, nationalities, isCountriesDataLoading, isCountriesDataHasError };
};
